import {makeTrackEvent} from './makeTrackEvent';

export type PanelBankAction =
  | 'Clear all panels'
  | 'Collapse all sections'
  | 'Expand all sections'
  | 'Pin panel bank section'
  | 'Unpin panel bank section';

export type PanelBankEvent = {
  action: PanelBankAction;
};

export const trackPanelBankEvent = makeTrackEvent<
  PanelBankEvent,
  {
    action: {
      description: 'the action that occurred';
    };
    _description: 'Track panel bank actions usage';
    _location: 'workspaces';
    _motivation: 'track UI usage';
  }
>('Panel bank actions');
